import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { Call } from '@entities/call';
import { Logger } from '@main/utils/logger';
import type { TransferNumberEventPublisher } from './warm-transfer-call.usecase';

export class TransferNumberPublisher implements TransferNumberEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish({ from, to }: Call): Promise<void> {
    const busIframe = await BusIframe.getIframe();
    const busEvent: BusEvent = {
      type: 'DIALER.START_WARM_TRANSFER',
      payload: {
        to: to,
        searchByTeam: to.startsWith('team:'),
      },
    };
    this.logger.info('Publisher: transfer number', {
      action: 'transferNumber',
      to,
      from,
    });

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
